module.exports = __webpack_public_path__ + "img/1-2.14c8d57d.svg";